// contexts/ReactionsContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';
import { useAuth } from '../global-components/src';

export interface ReactionType {
    slug: string;
    emoji: string;
    label: string;
}

const ReactionsContext = createContext<ReactionType[]>([]);

export const ReactionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { token } = useAuth();
    const [types, setTypes] = useState<ReactionType[]>([
        { slug: 'like', emoji: '❤️', label: 'Curtir' }, // fallback imediato
    ]);

    useEffect(() => {
        const loadTypes = () => {
            api(token).get('/reactions/types')
                .then(({ data }) => { setTypes(data); })
                .catch((error) => { console.error(error); }); // mantém fallback
        };

        loadTypes();
        window.addEventListener('pacoca-reactions-updated', loadTypes);

        return () => window.removeEventListener('pacoca-reactions-updated', loadTypes);
    }, [token]);

    return (
        <ReactionsContext.Provider value={types}>
            {children}
        </ReactionsContext.Provider>
    );
};

export const useReactionTypes = () => useContext(ReactionsContext);